"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useNinetailed } from "@ninetailed/experience.js-react";
import { ProductDetails, PricingCard } from "@/types/ecom";
import { pushDataLayerEvent } from "./utilities";
export const DatalayerPdpView = t0 => {
  const $ = _c(20);
  const {
    product,
    locale,
    pricingDataForDatalayer,
    cartId
  } = t0;
  const {
    track
  } = useNinetailed();
  const lastTrackedProductRef = useRef(null);
  let t1;
  if ($[0] !== pricingDataForDatalayer?.length || $[1] !== product?.productName || $[2] !== track) {
    t1 = () => {
      if (pricingDataForDatalayer?.length) {
        track("view_item", {
          product_name: product?.productName ?? ""
        });
      }
    };
    $[0] = pricingDataForDatalayer?.length;
    $[1] = product?.productName;
    $[2] = track;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = product?.productName;
  let t3;
  if ($[4] !== pricingDataForDatalayer || $[5] !== t2 || $[6] !== track) {
    t3 = [pricingDataForDatalayer, track, t2];
    $[4] = pricingDataForDatalayer;
    $[5] = t2;
    $[6] = track;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t1, t3);
  let t4;
  if ($[8] !== cartId || $[9] !== locale || $[10] !== pricingDataForDatalayer || $[11] !== product?._id || $[12] !== product?.sku) {
    t4 = () => {
      if (!pricingDataForDatalayer?.length) {
        return;
      }
      const trackingKey = `${product?._id || product?.sku || "unknown"}:${locale}`;
      if (lastTrackedProductRef.current === trackingKey) {
        return;
      }
      const formattedCards = pricingDataForDatalayer.map(_temp);
      pushDataLayerEvent({
        event: "view_item",
        ecommerce: {
          item_list_name: "User Cart",
          item_list_id: cartId ? cartId : product?._id,
          items: formattedCards
        }
      }, {
        clearEcommerce: true
      });
      lastTrackedProductRef.current = trackingKey;
    };
    $[8] = cartId;
    $[9] = locale;
    $[10] = pricingDataForDatalayer;
    $[11] = product?._id;
    $[12] = product?.sku;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = product?._id;
  const t6 = product?.sku;
  let t7;
  if ($[14] !== cartId || $[15] !== locale || $[16] !== pricingDataForDatalayer || $[17] !== t5 || $[18] !== t6) {
    t7 = [cartId, locale, pricingDataForDatalayer, t5, t6];
    $[14] = cartId;
    $[15] = locale;
    $[16] = pricingDataForDatalayer;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  useEffect(t4, t7);
  return null;
};
export default DatalayerPdpView;
function _temp(card) {
  return {
    ...card,
    quantity: 1
  };
}